import type { ReactNode } from "react";
import { cx } from "../cx";
import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  /** Icon or illustration. */
  media?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** `compact` for empty dropdowns and small cards. */
  size?: "default" | "compact";
  className?: string;
}

export function EmptyState({ media, title, description, action, size = "default", className }: EmptyStateProps) {
  return (
    <div className={cx(styles.empty, styles[size], className)}>
      {media && <div className={styles.media}>{media}</div>}
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
